/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestotal1Inputs */

const zh_learn_mistakestotal1 = /** @type {(inputs: Learn_Mistakestotal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错题总数`)
};

const en_learn_mistakestotal1 = /** @type {(inputs: Learn_Mistakestotal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Mistakes`)
};

const es_learn_mistakestotal1 = /** @type {(inputs: Learn_Mistakestotal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de errores`)
};

/**
* | output |
* | --- |
* | "Total Mistakes" |
*
* @param {Learn_Mistakestotal1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestotal1 = /** @type {((inputs?: Learn_Mistakestotal1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestotal1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestotal1(inputs)
	if (locale === "en") return en_learn_mistakestotal1(inputs)
	return es_learn_mistakestotal1(inputs)
});
export { learn_mistakestotal1 as "learn_mistakesTotal" }